<template>
  <div class="el-view" v-clickoutside="closePanel">
    <div class="el-view__header" @click="closePanel">
      <slot name="header"></slot>
    </div>
    <div class="el-view__body"  v-clickinside="{ selector: 'table.el-table__body', handler: closePanel }">
      <slot></slot>
    </div>
    <div class="el-view__footer" v-if="$slots.footer" @click="closePanel">
      <slot name="footer"></slot>
    </div>
    <slot name="subview"></slot>
  </div>
</template>

<script>
import event from '@/mixins/event'
import clickoutside from 'element-ui/lib/utils/clickoutside'
import clickinside from '@/directive/clickinside'

export default {
  name: 'ElView',
  mixins: [event],
  directives: { clickoutside, clickinside },
  data () {
    return {
    }
  },
  methods: {
    closePanel () {
      this.$event.$emit('panel:close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/View.vue